import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  customizeOrder: {
    id: 'customizeOrder',
    defaultMessage: 'Customize order'
  },
  cartridgeTooltip: {
    id: 'cartridgeTooltip',
    defaultMessage: `Oligo length has to be between 7 and 55 bases in 
    order to be purified by cartridge. 
    One or more of the oligos in your order has a length of 5 bases.`
  },
  platesizeTooltip: {
    id: 'platesizeTooltip',
    defaultMessage: 'This wells sequence template was not selected for the uploaded file.'
  }
});

export default { ...generalMessages, ...messages };
